class StickyNav {
  constructor() {
    this.distance = 100
    this.$container = $('body')
    this.$mainHeader = this.$container.find('.main-header')
    if (this.$mainHeader.length) {
      this.initialize();
    }
  }

  initialize() {
    this.scrollAction();
    $(window).resize(() => {
      this.scrollAction();
    });
    $(window).scroll(() => {
      this.scrollAction();
    });
  }

  scrollAction() {
    // - fix pour Safari qui retournes des valeurs négatives
    // -> $(window).scrollTop() sur le bounce
    const scrollTop = Math.max(window.pageYOffset,
      document.documentElement.scrollTop,
      document.body.scrollTop);
    if (scrollTop >= this.distance) {
      this.$mainHeader.addClass('scrolled')
    } else {
      this.$mainHeader.removeClass('scrolled');
    }
  }
}

export default StickyNav;



// WEBPACK FOOTER //
// ./scripts/navigation/StickyNav.js